import template from './jobsListItem.template.html';

export default {
  template,
  bindings: {
    job: '=',
    showsInAll: '<',
    accounts: '<',
    tickets: '<',
    workflows: '<',
    contacts: '<',
    labels: '<',
    showAssignedTo: '<',
    onToggle: '&',
    onEdit: '&',
    onDelete: '&',
    onLabelsSelect: '&',
    onChange: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, $mdDialog) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat();
        ctrl.job = ctrl.job || null;
        ctrl.accounts = ctrl.accounts || [];
        ctrl.tickets = ctrl.tickets || [];
        ctrl.workflows = ctrl.workflows || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.labels = ctrl.labels || [];
        ctrl.showAssignedTo = ctrl.showAssignedTo || false;
      };

      ctrl.select = (data) => {
        ctrl.onChange({ data });
      };

      ctrl.jobToggle = ($event, data) => {
        let canBeCompleted = true;
        if (data && data.items && data.items.length) {
          for (let s = 0; s < data.items.length; s += 1) {
            if (!data.items[s].isActive) {
              canBeCompleted = false;
              break;
            }
          }
        }
        if (canBeCompleted) {
          ctrl.onToggle({ data });
        } else {
          $mdDialog.show(
            $mdDialog
              .alert()
              .clickOutsideToClose(true)
              .title('Warning')
              .textContent('Not all sub-tasks have been completed.')
              .ariaLabel('Alert Dialog')
              .ok('Ok')
              .targetEvent($event)
          );
        }
      };

      ctrl.jobEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.jobDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.jobLabelsSelect = ($event, data) => {
        ctrl.onLabelsSelect({ event: $event, data });
      };

      ctrl.getAccount = (idAccount) => ctrl.accounts.find((a) => a.id === idAccount);

      ctrl.getTicket = (idTicket) => ctrl.tickets.find((t) => t.id === idTicket);

      ctrl.getWorkflow = (idWorkflow) => ctrl.workflows.find((w) => w.id === idWorkflow);

      ctrl.getStage = (idWorkflow, idTicket) => {
        const workflow = ctrl.getWorkflow(idWorkflow);
        let stage = '';
        if (workflow) {
          const { idStage } = ctrl.getTicket(idTicket);
          stage = workflow.stages.find((s) => s.id === idStage);
        }
        return stage;
      };

      ctrl.getContact = (idContact) => ctrl.contacts.find((c) => c.id === idContact);

      ctrl.getLabel = (idLabel) => ctrl.labels.find((l) => l.id === idLabel);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.jobs && changes.jobs.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
